module.exports = __webpack_public_path__ + "static/media/vinyl-record.735dc6c1.svg";